import { BreadcrumbLabel } from '@app/navigation/BreadcrumbLabel';
import { useGetInsightByIdQuery } from '@features/insight-findings/api/insight-findings.api';

interface InsightFindingsBreadcrumbParams {
  insightId?: string;
  traceId?: string;
}

export const InsightFindingsBreadcrumb = (params: InsightFindingsBreadcrumbParams) => {
  const insightId = params.insightId;
  const { data, isLoading } = useGetInsightByIdQuery(insightId ?? '', { skip: !insightId });

  return <BreadcrumbLabel label={data?.name ?? 'Insight Findings'} isLoading={isLoading} />;
};
